import {loadable} from 'router/routes';

const Confirmation = loadable(() => import('./Confirmation'));

export default Confirmation;
